import React, { Component } from 'react';
import deviceDOMHoc from '../../hocs/deviceDOMHoc';
import { NormalButton } from './components';
import {
  inject,
  observer,
} from 'mobx-react';
import { OUTPUT_TTL } from '../../constants/Pac';

@inject('batchStore')
@observer
class Aerator extends Component {

  render() {
    const { device, batchStore } = this.props;
    const active = batchStore.isOutputOn(device.switchPNo) ? 'active' : '';
    const btnClass = active ? 'active btn-batch-red' : 'btn-batch-green';
    const duration = active ? 0 : OUTPUT_TTL;

    return (
      <div id={`device-${device.id}`} className={`${active} device-gui device-gui--aerator device-icon-${device.icon}`}>
        {device.description && (
          <div className="device-label device-icon">
            <div className="device-type" title={`#${device.id}`}>{device.description}</div>
          </div>
        )}
        <div className="device-icon disc"/>
        <div className="device-icon stick"/>
        <div className="device-icon puff puff-left"/>
        <div className="device-icon puff puff-right"/>
        <div className="device-gui__row">
          <NormalButton className={`btn-batch ${btnClass}`}
            port={device.switchPNo}
            duration={duration}>
            <i className="fa fa-power-off" />
          </NormalButton>
        </div>
      </div>
    );
  }
}

export default deviceDOMHoc(Aerator);
